<ui-grid [data]="data$ | async"
         [loading]="loading$ | async">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="main">
            <ng-template>
                <button [uiAuthorize]="'Assets.Create'"
                        [matTooltip]="'grid_action_add' | translate"
                        [uiClickTrack]="'Action: Add Asset'"
                        (click)="openModal()"
                        mat-mini-fab
                        color="primary"
                        data-cy="asset-add"
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorize]="'Assets.Delete'"
                        [disabled]="!allowDelete"
                        [matTooltip]="'assets_grid_action_remove' | translate"
                        (click)="removeItems()"
                        mat-icon-button
                        color="warn"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete20px"></mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [title]="'assets_grid_name' | translate"
                    [searchable]="true"
                    [sortable]="true"
                    [primary]="true"
                    sort="asc"
                    property="name"
                    width="30%">
    </ui-grid-column>
    <ui-grid-column [title]="'assets_grid_description' | translate"
                    [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    property="description"
                    width="25%">
    </ui-grid-column>
    <ui-grid-column [title]="'assets_grid_type' | translate"
                    [sortable]="true"
                    property="type"
                    width="30%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('AssetType_' + entry.type) | translate as assetTypeText">
                <span [matTooltip]="assetTypeText">{{assetTypeText}}</span>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'assets_grid_value' | translate"
                    [primary]="true"
                    property="value"
                    width="40%">
        <ng-template let-index="index"
                     let-entry="data">
            <ng-container *ngLet="{
                             credentialText: ('assets_credential_store_value' | translate),
                             robotText: ('assets_grid_value_per_robot_message' | translate)
                          } as localized">
                <em #credentialValue
                    *ngIf="entry.type === 'Credential'; else globalValue"
                    [matTooltip]="credentialValue.innerText">
                    {{ localized.credentialText }}
                </em>
                <ng-template #globalValue>
                    <ng-container *ngIf="entry.scope !== 'Global'; else global_scope">
                        <em [matTooltip]="localized.robotText">
                            {{ localized.robotText }}
                        </em>
                    </ng-container>
                    <ng-template #global_scope>
                        <ng-container *ngIf="entry.type === 'Bool'; else notBool">
                            <ng-container *ngLet="((
                                entry.boolValue ?
                                'assets_modal_form_bool_true' :
                                'assets_modal_form_bool_false'
                                ) | translate) as boolText">
                                <span [matTooltip]="boolText">
                                    {{ boolText }}
                                </span>
                            </ng-container>
                        </ng-container>
                        <ng-template #notBool>
                            <span [matTooltip]="entry.value">
                                {{ entry.value }}
                            </span>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [uiAuthorizeAnyDisable]="['Assets.Edit', 'Assets.Delete']"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    [matMenuTriggerFor]="menu"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [uiAuthorize]="'Assets.Edit'"
                        [uiClickTrack]="'Action: Grid: Edit'"
                        [disableIf]="loadingModal$ | async"
                        (click)="openModal(entry)"
                        mat-menu-item
                        data-cy="asset-edit"
                        type="button">
                    <mat-icon svgIcon="uipath:Edit"></mat-icon>
                    {{ 'assets_grid_action_edit' | translate }}
                </button>
                <button [uiAuthorize]="'Assets.Delete'"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeItems([entry])"
                        mat-menu-item
                        color="warn"
                        data-cy="asset-remove"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    {{ 'assets_grid_action_remove' | translate }}
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
